/**
 * Labstep
 *
 * @module components/Toast
 * @desc A dummy component to fire toasts
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ErrorBoundaryContainer } from 'labstep-web/containers/ErrorBoundary';
import { withUi } from 'labstep-web/containers/Ui';
import { withToast } from 'labstep-web/containers/Ui/Toast';
import { Toast as CoreToast } from 'labstep-web/core/Toast';
import React from 'react';
import hotToast from 'react-hot-toast';
import { v4 } from 'uuid';
import type { IToastProps } from './types';
import { getToastParams } from './utils';

export class Toast extends React.Component<IToastProps> {
  public componentDidUpdate(prevProps: IToastProps): void {
    const { toast, activeGroup } = this.props;

    if (toast.timestamp !== prevProps.toast.timestamp) {
      const params = getToastParams(toast, activeGroup);
      const id = v4();
      if (params !== null) {
        const { type, message, options = {} } = params;
        if (type in hotToast) {
          hotToast[type as 'success' | 'error'](
            () => (
              <CoreToast
                message={message}
                options={{ type, ...options }}
                close={(): void => hotToast.dismiss(id)}
              />
            ),
            {
              duration: options.timeout || 5000,
              position: 'top-right',
              id,
            },
          );
        }
      }
    }
  }

  public render(): React.ReactElement {
    return (
      <ErrorBoundaryContainer FallbackComponent={<span />}>
        <span />
      </ErrorBoundaryContainer>
    );
  }
}

export default withToast(withUi(withActiveGroup(Toast)));
